document.addEventListener("alpine:init", () => {
  Alpine.data("PasswordFreePopup", () => ({
    email: "",
    verificationCode: "",
    loading: false,
    submitting: false,
    isNewUser: null,
    isEmailChecked: false,
    isAgree: true, // New user disclaimer agreement
    isSubscribe: false,
    isLoggedIn: false,
    errMsg: "",
    emailErrMsg: "",
    countdown: 0,
    countdownInterval: null,

    get canSubmit() {
      if (this.isNewUser) {
        return this.email &&
          this.verificationCode &&
          !this.emailErrMsg &&
          this.isEmailChecked &&
          this.isAgree;
      }
      return this.email &&
        this.verificationCode &&
        !this.emailErrMsg &&
        this.isEmailChecked;
    },

    validateEmail(email) {
      const emailRegex = /^[A-Za-z\d]+([.%~`$^*&(){}<>?"+=!_\\-]*[A-Za-z\d-])*@[a-zA-Z\d-]{1,30}\.[a-zA-Z\d.%#~`$^*&(){}<>?"+=!_\\-]{1,30}$/;
      return emailRegex.test(email);
    },

    async checkEmail(email) {
      const encodedEmail = encodeURIComponent(email);
      const checkEmailApi = `${theme.emailSubscription.apiDomain}/usercenter/inuc/checkEmail?email=${encodedEmail}`;
      this.loading = true;
      try {
        const response = await fetch(checkEmailApi, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': 'en-UK,en;q=0.9'
          }
        });

        const data = await response.json();

        if (data.code === "1003") {
          this.isEmailChecked = true;
          return { isNewUser: true };
        } else if (data.code === "0") {
          this.isEmailChecked = true;
          return { isNewUser: false };
        } else if (data.code !== "0" && data.code !== "1003") {
          throw new Error(data.message);
        }
      } catch (error) {
        console.error('Error checking email:', error);
        throw new Error(error.message || "Failed to check email. Please try again.");
      } finally {
        this.loading = false;
      }
    },

    async getVerificationCode(email) {
      const getVerificationCodeApi = `${theme.emailSubscription.apiDomain}/auth/verificationCode/send`;
      this.loading = true;
      try {
        const apiScene = this.isNewUser ? 'SHOPIFY_REGISTER_VERIFICATION_CODE' : 'SHOPIFY_LOGIN_VERIFICATION_CODE';
        const response = await fetch(getVerificationCodeApi, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': 'en-UK,en;q=0.9'
          },
          body: JSON.stringify({ account: email, scene: apiScene })
        });

        const data = await response.json();
        if (data.code !== "0") {
          throw new Error(data.message);
        }
        return data;
      } catch (error) {
        console.error('Error getting verification code:', error);
        this.errMsg = error.message || "Failed to send verification code. Please try again.";
        throw new Error(error.message);
      } finally {
        this.loading = false;
      }
    },

    async loginWithVerficiationCode() {
      const loginWithVerficiationCodeApi = `${theme.emailSubscription.apiDomain}/auth/login`;
      const apiBody = {
        source: "SHOPIFY_UNITED_KINGDOM",
        email: this.email,
        userType: "ECOFLOW",
        scene: "SHOPIFY_UNITED_KINGDOM",
        verificationCode: this.verificationCode,
        logInSource: 1,
        entry_name: "top floating_Password-free Register",
        page_url: window.location.href,
        source_channel: "Shopify",
        returnTo: window.location.href
      };
      this.loading = true;
      try {
        const response = await fetch(loginWithVerficiationCodeApi, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': 'en-UK,en;q=0.9',
            "systemName": "shopify_user"
          },
          body: JSON.stringify(apiBody)
        });
        const data = await response.json();
        if (data.code !== "0") {
          throw new Error(data.message);
        }
        return data;
      } catch (error) {
        console.error('Error logging in:', error);
        this.errMsg = error.message || "Login failed. Please try again.";
        throw new Error(error.message);
      } finally {
        this.loading = false;
      }
    },

    async registerWithVerificationCode() {
      const registerWithVerificationCodeApi = `${theme.emailSubscription.apiDomain}/auth/quicklyRegisterLogin`;
      const apiBody = {
        source: "SHOPIFY_UNITED_KINGDOM",
        email: this.email,
        userType: "ECOFLOW",
        scene: "SHOPIFY_UNITED_KINGDOM",
        code: this.verificationCode,
        logInSource: 1,
        entry_name: "top floating_Password-free Register",
        page_url: window.location.href,
        source_channel: "Shopify",
        returnTo: window.location.href,
        isAgree: this.isAgree,
      };
      this.loading = true;
      try {
        const response = await fetch(registerWithVerificationCodeApi, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': 'en-UK,en;q=0.9',
            'systemName': 'shopify_user'
          },
          body: JSON.stringify(apiBody)
        });
        const data = await response.json();
        if (data.code !== "0") {
          throw new Error(data.message);
        }
        return data;
      } catch (error) {
        console.error('Error registering:', error);
        this.errMsg = error.message || "Register failed. Please try again.";
        throw new Error(error.message);
      } finally {
        this.loading = false;
      }
    },

    async handleEmailBlur() {
      const emailValue = this.email.trim();
      this.emailErrMsg = "";

      if (!emailValue) {
        this.emailErrMsg = email_empty_error_message;
        return;
      }

      if (!this.validateEmail(emailValue)) {
        this.emailErrMsg = email_invalid_error_message;
        return;
      }

      const result = await this.checkEmail(emailValue);

      if (result.error) {
        this.emailErrMsg = result.error;
        this.isNewUser = null;
        return;
      }
      this.isNewUser = result.isNewUser;
    },

    startCountdown() {
      // Clear any existing countdown
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }

      // Set countdown to 60 seconds
      this.countdown = 60;

      // Start the countdown interval
      this.countdownInterval = setInterval(() => {
        this.countdown--;

        if (this.countdown <= 0) {
          clearInterval(this.countdownInterval);
          this.countdownInterval = null;
          this.countdown = 0;
        }
      }, 1000);
    },

    clearCountdown() {
      // TODO: Remove if not needed
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
      this.countdown = 0;
    },

    createTraceId() {
      const date = new Date();
      const year = `00${date?.getFullYear()}`.slice(-2);
      const month = `00${date.getMonth() + 1}`.slice(-2);
      const day = `00${date.getDay()}`.slice(-2);
      const hour = `00${date.getHours()}`.slice(-2);
      const minute = `00${date.getMinutes()}`.slice(-2);
      const second = `00${date.getSeconds()}`.slice(-2);
      const millSecond = `000${date.getMilliseconds()}`.slice(-3);
      const randomStr1 = `${Math.random()}`;
      const randomStr2 = `${Math.random()}`;
      return (
        year +
        month +
        day +
        hour +
        minute +
        second +
        millSecond +
        randomStr1.slice(-8) +
        randomStr2.slice(-9)
      );
    },

    async handleGetVerificationCode() {
      const emailValue = this.email.trim();
      this.emailErrMsg = "";
      this.errMsg = "";

      if (!emailValue) {
        this.emailErrMsg = email_empty_error_message;
        return;
      }

      if (!this.validateEmail(emailValue)) {
        this.emailErrMsg = email_invalid_error_message;
        return;
      }

      this.loading = true;

      try {
        this.startCountdown();
        const result = await this.getVerificationCode(emailValue);

        if (result.error) {
          this.errMsg = result.error;
        } else {
          this.errMsg = "";
          // Start countdown only on successful code send
        }
      } catch (error) {
        this.errMsg = error.message || "Failed to send verification code. Please try again.";
        console.error('Error:', error);
      } finally {
        this.loading = false;
      }
    },

    async handleLogin() {
      if (!this.canSubmit) {
        return;
      }

      this.submitting = true;
      this.errMsg = "";

      try {
        const result = await this.loginWithVerficiationCode();

        if (result.error) {
          this.errMsg = result.error;
          return;
        }

        const { data } = result;

        if (data) {
          setCookieWithDomain('uk-token', data.token, 7, '.ecoflow.com');
          setCookieWithDomain('userInfo', JSON.stringify({ user: data.user, token: data.token }), 7, '.ecoflow.com');
          setCookieWithDomain('ef_uid', data.user?.userId || "", 7, '.ecoflow.com');
          this.isLoggedIn = true;
          window.location.replace(`${data.redirectUrl}`);
        }
      } catch (error) {
        this.errMsg = error.message || "Login failed. Please try again.";
        console.error('Error:', error);
      } finally {
        this.submitting = false;
      }
    },

    async handleRegister() {
      if (!this.canSubmit) {
        return;
      }

      this.submitting = true;
      this.errMsg = "";

      try {
        const result = await this.registerWithVerificationCode();

        if (result.error) {
          this.errMsg = result.error;
          return;
        }

        const { data } = result;

        if (data) {
          setCookieWithDomain('uk-token', data.token, 7, '.ecoflow.com');
          setCookieWithDomain('userInfo', JSON.stringify({ user: data.user, token: data.token }), 7, '.ecoflow.com');
          setCookieWithDomain('ef_uid', data.user?.userId || "", 7, '.ecoflow.com');

          if (this.isSubscribe) {
            const { acceptedLanguage, apiKey, xAppid, apiUrl } = theme.emailSubscription;
            const traceId = this.createTraceId();
            const subscribeInfoCookie = window.getCookieForEmarsys('signup_info');
            let eventTracking = null;

            if (subscribeInfoCookie) {
              try {
                const decodedCookie = decodeURIComponent(subscribeInfoCookie)
                eventTracking = JSON.parse(decodedCookie);
                delete eventTracking.ts
                console.log('signup_info eventTracking', eventTracking);
              } catch (error) {
                console.log('signup_info eventTracking error', subscribeInfoCookie);
                console.warn('Failed to parse signup_info cookie:', error);
              }
            };
            const emarsysFields = {
              email: this.email,
              source: "SHOPIFY_REGISTER",
              ...(eventTracking && { eventTracking }),
              contactListId: pw_free_register_emarsys_contact_list_id,
              fields: [
                {
                  id: pw_free_register_emarsys_s_1_id,
                  type: "single",
                  value: Number(pw_free_register_emarsys_s_1_value),
                  overwrite: JSON.parse(pw_free_register_emarsys_s_1_overwrite),
                },
                {
                  id: pw_free_register_emarsys_s_2_id,
                  type: "single",
                  value: Number(pw_free_register_emarsys_s_2_value),
                  overwrite: JSON.parse(pw_free_register_emarsys_s_2_overwrite),
                },
                {
                  id: pw_free_register_emarsys_m_1_id,
                  type: "multiple",
                  value: pw_free_register_emarsys_m_1_value.split(',').map(Number),
                  overwrite: JSON.parse(pw_free_register_emarsys_m_1_overwrite),
                }
              ]
            };
            const emarsysSubscribeResponse = await fetch(apiUrl, {
              method: 'POST',
              headers: {
                "Content-Type": "application/json",
                apiKey: apiKey,
                traceId: traceId,
                "X-appid": xAppid,
                "Accept-Language": acceptedLanguage,
              },
              body: JSON.stringify(emarsysFields)
            });
            const emarsysData = await emarsysSubscribeResponse.json();
          }

          this.isLoggedIn = true;
          window.location.replace(`${data.redirectUrl}`);
        }
      } catch (error) {
        this.errMsg = error.message || "Register failed. Please try again.";
        console.error('Error:', error);
      } finally {
        this.submitting = false;
      }
    },

    async handleSocialLogin(provider) {
      try {
        const socialLoginUrl = `${theme.emailSubscription.apiDomain}/auth/oauth/webLoginUrl/${provider}?returnTo=${encodeURIComponent(window.location.href)}`;
        const response = await fetch(socialLoginUrl);
        const data = await response.json();
        if (data && data.code !== "0") {
          this.errMsg = data.message;
          throw new Error(data.message);
        }
        if (data && data.code === "0" && data.data?.redirectUrl) {
          window.location.href = data.data.redirectUrl;
        } else {
          this.errMsg = data.message;
          throw new Error(data.message);
        }
      } catch (error) {
        this.errMsg = error.message || "Social login failed. Please try again.";
        console.error('Error:', error);
      }
    },
  }));
});

function closeLoginPopupDialog() {
  const dialog = document.getElementById('login-popup-dialog');
  if (dialog) {
    dialog.close();
  }
}

function openLoginPopupDialog() {
  const dialog = document.getElementById('login-popup-dialog');
  if (dialog) {
    dialog.showModal();
  }
}

function setCookieWithDomain(name, value, days, domain) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/; domain=" + domain;
}

window.openLoginPopupDialog = openLoginPopupDialog;
window.closeLoginPopupDialog = closeLoginPopupDialog;
